import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Button, Divider, Icon, VStack } from "native-base";
import React from "react";
import { Linking, Text } from "react-native";

import Modal from "@/components/molecules/Modal";
import { POLICY_URL, TERMS_URL } from "@/config/constants";

type TermsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const TermsModal = ({ isOpen, onClose }: TermsModalProps) => {
  const onPressContact = (type: "terms" | "policy") => {
    switch (type) {
      case "terms":
        Linking.openURL(TERMS_URL);
        break;
      case "policy":
        Linking.openURL(POLICY_URL);
        break;
      default:
        break;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header="Termos e Condições"
      Body={
        <VStack pb="24">
          <Button
            py="4"
            justifyContent="flex-start"
            variant="ghost"
            onPress={() => onPressContact("terms")}
            leftIcon={
              <Icon
                as={<MaterialCommunityIcons name="file-outline" />}
                size="lg"
                color="primary.600"
              />
            }>
            <Text>Termos de Uso</Text>
          </Button>
          <Divider />
          <Button
            py="4"
            justifyContent="flex-start"
            variant="ghost"
            onPress={() => onPressContact("policy")}
            leftIcon={
              <Icon
                as={<MaterialCommunityIcons name="file-outline" />}
                size="lg"
                color="primary.600"
              />
            }>
            <Text>Política de Privacidade</Text>
          </Button>
          <Divider />
        </VStack>
      }
    />
  );
};

export default TermsModal;
